
import {
  Menu,
  MenuItem,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import {
  menuUtil,
  useAccessState
} from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import {
  DeleteFolderModal,
  DuplicateFolderModal,
  SaveFolderModal
} from 'modules/components/layer17';
import { useState } from 'react';



export type FolderMenuProps = menuUtil.IBaseMenuProps & {

};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: FolderMenuProps) => {

  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  const [
    isDeleteVisible,
    setIsDeleteVisible
  ] = useState(false);

  const [
    isDuplicateVisible,
    setIsDuplicateVisible
  ] = useState(false);

  const access = useAccessState('Folder');

  return (
    <>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        id={props.id}
        open={props.open}
        anchorEl={props.anchorEl ?? null}
        onClose={() => props.handleClose()}
      >

        <MenuItem
          disabled={!access.update}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setIsVisible(() => true);
          }}
        >
          <Stack
            direction='row'
            columnGap='.5rem'
          >
            <CustomIcon.large.FC
              icon='EDITALT'
              stroke={theme.palette.primary.main}
            />
            <Typography
              variant='menuItem'
            >
              Edit
            </Typography>
          </Stack>
        </MenuItem>
        <MenuItem
          disabled={!access.delete}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setIsDeleteVisible(() => true);

          }}
        >
          <Stack
            direction='row'
            columnGap='.5rem'
          >
            <CustomIcon.large.FC
              icon='DELETE'
              stroke={theme.palette.error.main}
            />
            <Typography
              variant='menuItem'
            >
              Delete Folder
            </Typography>
          </Stack>
        </MenuItem>
        <MenuItem
          disabled={!access.create}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setIsDuplicateVisible(() => true);

          }}
        >
          <Stack
            direction='row'
            columnGap='.5rem'
          >
            <CustomIcon.large.FC
              icon='DUPLICATE'
              stroke={theme.palette.primary.main}
            />
            <Typography
              variant='menuItem'
            >
              Duplicate Folder
            </Typography>
          </Stack>
        </MenuItem>
      </Menu>
      {isDuplicateVisible && (
        <DuplicateFolderModal.FC
          id={props.id}
          isVisible={isDuplicateVisible}
          handleClose={() => {
            props.handleClose();
            setIsDuplicateVisible(() => false);
          }}
        />
      )}
      {isDeleteVisible && (
        <DeleteFolderModal.FC
          id={props.id}
          isVisible={isDeleteVisible}
          handleClose={() => {
            props.handleClose();
            setIsDeleteVisible(() => false);
          }}
        />
      )}
      {isVisible && (
        <SaveFolderModal.FC
          id={props.id}
          isVisible={isVisible}
          handleClose={() => {
            props.handleClose();
            setIsVisible(() => false);
          }}
        />
      )}
    </>
  );
};
